
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showNotification, showErrors } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppSimpleButton from '@/components/AppSimpleButton.vue'
import GoodsDialog from '../GoodsList/script-dialog'
import { changeGoodsStatus } from '../GoodsList/gql'
import { SnackType } from '@/interfaces/snack'
import AppTab from '@/components/AppTab.vue'
import { auditStatusText } from '@/helpers/audit'
import { DealerModel, DealersOrderBy } from '@/interfaces/dealer'
import { findDealers } from '../DealerList/gql'
import { TypedGqlError } from '@/interfaces/error'
import { assignGoodToDealers, removeGoodFromDealers } from './gql'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import AppTextField from '@/components/AppTextField.vue'
import { formatCurrency } from '@/utils/currency'

@Component({
  components: {
    AppBreadcrumbs,
    AppDialog,
    AppSimpleButton,
    AppTab,
    AppSearchBtn,
    AppTextField
  }
})

export default class GoodsDetail extends mixins(GoodsDialog) {
  // 面包屑
  breadcrumbs: Breadcrumb[] = [
    {
      text: '商品管理'
    },
    {
      text: '商品品类',
      to: { name: 'GoodsList' },
      exact: true
    }
  ]

  goodId = ''
  formatCurrency = formatCurrency

  windowSize = {
    w: 0,
    h: 0
  }

  actionsHeight = 51

  activeTab = 0

  headers = [
    { text: '姓名', value: 'dealer.realname', sortable: false },
    { text: '手机号', value: 'dealer.user.phone', sortable: false },
    { text: '店铺名称', value: 'dealer.storeName', sortable: false },
    { text: '店铺电话', value: 'dealer.storePhone', sortable: false },
    { text: '状态', value: 'dealer.status', sortable: false },
    { text: '操作', value: 'actions', sortable: false, align: 'end' }
  ]

  filterHeaders = [
    { text: '姓名', value: 'realname', sortable: false },
    { text: '店铺名称', value: 'storeName', sortable: false },
    { text: '手机号', value: 'user.phone', sortable: false }
  ]

  options = {
    sortBy: ['realname'],
    sortDesc: [true]
  }

  loading = false
  filterLoading = false

  dealers: any = []

  auditStatusText = auditStatusText

  allDealers: DealerModel[] | null = null
  selectedDealers: DealerModel[] | null = null;

  DealersOrderBy = DealersOrderBy

  addDealers = {
    title: '添加经销商',
    show: false
  };

  deleteDealerDialog = {
    show: false,
    text: ''
  }

  targetDealer: any

  filter = { realname: '' }
  disPlayDealers: DealerModel[] | null = null

  isQuery = false

  get modifiedBy () {
    return this.targetgoods?.managers.modifiedBy.username || '-'
  }

  get createdBy () {
    return this.targetgoods?.managers.createdBy.username || '-'
  }

  get editTime () {
    return this.utcDateTimeToLocal(this.targetgoods?.updatedAt + '') || '-'
  }

  get actionLabel () {
    return this.targetgoods?.status === 'OFF_SHELVES' ? '上架' : '下架'
  }

  get thumb () {
    return this.targetgoods?.thumb || this.targetgoods?.coverImages[0] || ''
  }

  get filterDealers () {
    if (this.allDealers?.length !== 0) {
      return this.allDealers?.filter((item) => {
        return !this.dealers?.some((ele: any) => ele.dealer.id === item.id)
      })
    } else {
      return []
    }
  }

  get items () {
    return this.getRole() === 'dealer'
      ? ['商品详情']
      : ['商品详情', '经销商']
  }

  @Watch('filterDealers', { deep: true })
  filterDealersChange (val: DealerModel[]) {
    this.disPlayDealers = val
  }

  async mounted () {
    this.onResize()
    if (this.getRole() === 'dealer') {
      this.headers.pop()
    }
    // 缓存数据
    const { id } = this.$route.params
    this.goodId = id
    this.targetgoods = await this.getGoodsById(Number(this.goodId))
    this.dealers = this.targetgoods?.dealerRelations
    this.breadcrumbs.push({ text: `${this.targetgoods?.title}` })
    await this.getAllDealers()
    this.disPlayDealers = this.filterDealers as DealerModel[]
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  // 切换tab
  changeTab (val: number) {
    this.activeTab = val
  }

  // 确认删除
  async deleteDialogConfirm () {
    await this.deleteGoodsRequest()
    this.$router.push({
      name: 'GoodsList'
    })
  }

  async takeDownById () {
    const msg = this.actionLabel
    const goodIds = [+this.goodId]
    const status = this.targetgoods?.status === this.GoodsStatus.OFF_SHELVES ? this.GoodsStatus.ON_SHELVES : this.GoodsStatus.OFF_SHELVES
    const result = await this.$apollo.mutate({
      mutation: changeGoodsStatus,
      variables: {
        goodIds,
        status
      }
    })
    if (result) {
      showNotification({
        msg: `${msg}成功！`,
        type: SnackType.Success
      })
      this.targetgoods = await this.getGoodsById(+this.goodId)
      this.dealers = this.targetgoods?.dealerRelations
    } else {
      showNotification({
        msg: `${msg}失败！`,
        type: SnackType.Error
      })
    }
  }

  // 把商品分配多个经销商
  async addDealersConfirm () {
    const dealers = this.selectedDealers?.map((item: DealerModel) => {
      return {
        dealerId: item.id
      }
    })

    try {
      const result = await this.$apollo.mutate({
        mutation: assignGoodToDealers,
        variables: {
          goodId: Number(this.goodId + ''),
          dealers
        }
      })
      if (result) {
        this.addDealers.show = false
        this.filter.realname = ''
        this.selectedDealers = []
        showNotification({
          msg: '添加成功',
          type: SnackType.Info
        })
        const goods = await this.getGoodsById(Number(this.goodId))
        this.dealers = goods.dealerRelations
      } else {
        showNotification({
          msg: '添加失败',
          type: SnackType.Error
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  deleteHandler () {
    //
  }

  // 删选经销商
  filterQuerySubmit () {
    const { realname } = this.filter
    this.disPlayDealers = this.filterDealers?.filter((item: DealerModel) => {
      return item.realname.includes(realname)
    }) as DealerModel[]
  }

  // 获取全部经销商
  async getAllDealers () {
    try {
      const result = await this.$apollo.query({
        query: findDealers,
        variables: {
          order: {
            asc: true,
            by: DealersOrderBy.realname
          },
          paging: {
            skip: 0,
            take: 500
          }
        }

      })
      this.allDealers = result.data.findDealers.dealers
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 显示删除经销商弹框
  async deleteDealer (item: any) {
    this.deleteDealerDialog.show = true
    this.deleteDealerDialog.text = `是否删除经销商：${item.realname}?`
    this.targetDealer = item
  }

  // 确认删除经销商
  async deleteDealerConfirm () {
    const dealerIds: any = [this.targetDealer.id]
    try {
      const result = await this.$apollo.query({
        query: removeGoodFromDealers,
        variables: {
          dealerIds,
          goodId: +this.goodId
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功',
          type: SnackType.Info
        })
        const goods = await this.getGoodsById(Number(this.goodId))
        this.dealers = goods.dealerRelations
        this.deleteDealerDialog.show = false
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  addDealersCancel () {
    this.selectedDealers = []
    this.disPlayDealers = this.filterDealers as DealerModel[]
    this.filter.realname = ''
  }
}
